import type { ReactNode } from "react";
import { createContext, useContext } from "react";

import type { SidebarResource } from "./types.ts";

type SidebarPanelContext = {
  isOpen: boolean;

  openPanel: () => void;
  closePanel: () => void;
};

type SidebarContext = {
  main: SidebarPanelContext & {
    selectedResourceName?: string;
  };
  popOut: SidebarPanelContext & {
    setPanelByName: (name: SidebarResource["name"]) => void;

    // note: a panel may be explicitly set, and in doing so, it takes priority until another panel is selected by name
    //       this panel should *not* contain any node designers (which may be deleted at any time)
    setPanelDangerously: (panel: ReactNode) => void;

    panelName?: SidebarResource["name"];
    getPanel: (resources: SidebarResource[]) => ReactNode;
  };
  selectMainPanelByName: (name: SidebarResource["name"]) => void;
};

export const SidebarContext = createContext<SidebarContext | undefined>(undefined);

export const useSidebar = () => {
  const context = useContext(SidebarContext);

  if (!context) {
    throw new Error(`Expected SidebarContextProvider in ancestor tree.`);
  }

  return context;
};
